export default "/static/dashboard/build/app/img/v2/e2119e3cc864c4cd9c14a2891993ba97.png";